
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/v2/auth/login",
      function () {
        return require("private-next-pages/v2/auth/login.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/v2/auth/login"])
      });
    }
  